import { render, staticRenderFns } from "./PasswordChangeForm.vue?vue&type=template&id=00612e42&scoped=true&lang=pug&"
import script from "./PasswordChangeForm.vue?vue&type=script&lang=js&"
export * from "./PasswordChangeForm.vue?vue&type=script&lang=js&"
import style0 from "./PasswordChangeForm.vue?vue&type=style&index=0&id=00612e42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00612e42",
  null
  
)

export default component.exports